import moment from 'moment'
import store from '@state/store'

// set locale when app starts
// todo: maybe not needed, just use formatDateMoment everywhere
moment.locale(store.getters['auth/language'])
